Px.Editor.FbImageModel = class FbImageModel extends Px.Editor.BaseTaggedImageModel {};
